import React from "react";
import withStyles from "react-jss";
import PropTypes from "prop-types";
import classNames from "classnames";

const contactsStyle = theme => ({
    root: {
        padding: "14px 0 0",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        "& div:first-child": {
            fontFamily: theme.fonts.medium,
            fontSize: "14px",
            lineHeight: "1.86",
            letterSpacing: "2px",
            color: theme.palette.colors.oneMoreGrey,
            textTransform: "uppercase",
            marginRight: "12px",
        },
        "& div:last-child": {
            fontFamily: theme.fonts.bold,
            fontSize: "18px",
            lineHeight: "1.44",
            textAlign: "right",
            color: theme.palette.colors.darkSlateBlue,
        },
    },
    yandexReview: {
        justifyContent: "center",
    },
    [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
        root: {
            flexWrap: "wrap",
            "& div:first-child": {
                width: "100%",
            },
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            marginBottom: "0",
            display: "flex",
            justifyContent: "flex-start",
            padding: "0",
            "& div:first-child": {
                marginRight: "12px",
            },
        },
        yandexReview: {
            justifyContent: "center",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            marginBottom: "0",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            padding: "0",
            "& div:first-child": {
                marginRight: "12px",
            },
        },
        yandexReview: {
            justifyContent: "center",
        },
    },
});

const Contacts = withStyles(contactsStyle)(
    ({ children, classes, yandexReview, homeOrder }) => {
        return (
            <div
                className={classNames(classes.root, {
                    [classes.yandexReview]: yandexReview,
                })}
            >
                {children}
            </div>
        );
    }
);
Contacts.propTypes = {
    children: PropTypes.node,
};
export default Contacts;
